import React from "react";
import { inject, observer } from "mobx-react";

// Datasets that contributed evidence to the top-ranked search results.
// Sourced from the `datasets_used` field on search_results SSE events;
// rendered as a row of chips inline below the assistant message.

const DatasetChipsCard = inject("searchSessionStore")(observer(({ datasetsUsed, searchSessionStore }) => {
  if (!Array.isArray(datasetsUsed) || datasetsUsed.length === 0) return null;

  const catalog = searchSessionStore?.datasets || {};
  const items = datasetsUsed.map(key => ({
    key,
    name: catalog[key]?.name || key,
  }));

  return (
    <div style={{
      margin: "6px 0 10px",
      padding: "10px 12px",
      background: "#fafaf9",
      border: "1px solid #e7e5e4",
      borderRadius: "6px",
      fontFamily: "inherit",
    }}>
      <div style={{
        fontSize: "11px",
        color: "#57534e",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        fontWeight: 600,
        marginBottom: "6px",
      }}>
        Datasets contributing to these results
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
        {items.map(d => (
          <span
            key={d.key}
            title={d.key}
            style={{
              padding: "3px 9px",
              fontSize: "12px",
              color: "#374151",
              background: "#f3f4f6",
              border: "1px solid #d1d5db",
              borderRadius: "12px",
              fontFamily: "inherit",
              lineHeight: "1.5",
            }}
          >
            {d.name}
          </span>
        ))}
      </div>
    </div>
  );
}));

export default DatasetChipsCard;
